<template>
  <div>
    <div class="cancel-btn" @click="show(false)">
      <b-icon
        v-if="windowWidth < 700 && showSearch"
        icon="close"
        size="is-small"
      ></b-icon>
    </div>
    <div
      v-if="windowWidth >= 700 || showSearch"
      :class="
        windowWidth < 700 && showSearch ? 'search-input-mobile' : 'search-input'
      "
    >
      <searchInput :value="value" @input="input"></searchInput>
    </div>
    <div
      :class="!loggedIn ? `${view}-btn` : `${view}-btn-loggedIn`"
      @click="show(true)"
    >
      <b-icon
        class="search-icon"
        v-if="windowWidth < 700 && !showSearch"
        icon="magnify"
        size="is-medium"
      ></b-icon>
    </div>
  </div>
</template>

<script>
import SearchInput from "../core/SearchInput";

export default {
  name: "search",
  components: {
    SearchInput
  },
  props: {
    view: {
      type: String,
      default: "search"
    },
    loggedIn: {
      type: Object,
      default: null
    },
    value: {
      type: String,
      default: ""
    },
    showSearchInput: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: null,
      showSearch: false
    };
  },
  created() {
    this.showSearch = this.showSearchInput;
  },
  methods: {
    show(visible) {
      this.showSearch = visible;
      this.$emit("show", visible);
    },
    input(value) {
      this.$emit("input", value);
    }
  }
};
</script>
